import { useState } from "react";

type ClosedMode = { type: "closed" };

export function useSheetMode<T extends { type: string }>() {
  const [mode, setMode] = useState<T | ClosedMode>({ type: "closed" });

  function close() {
    setMode({ type: "closed" });
  }

  const isOpen = mode.type !== "closed";

  return { mode, setMode, close, isOpen };
}
